import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { playHomeReveal } from './home-flow';

// plainExit : sortie classique (le loader remonte) même sur la home,
// utilisée au rechargement d'une page déjà scrollée
export const initLoader = (startSiteCallback, { plainExit = false } = {}) => {
    return new Promise((resolve) => {
        const overlay    = document.getElementById('loader-overlay');
        const bg         = document.getElementById('loader-bg');
        const loaderText = document.getElementById('loader-text');
        const subtitle   = document.getElementById('loader-subtitle');
        const logo       = document.getElementById('loader-logo-svg');
        const logoParts  = ["#logo-rect", "#logo-poly", "#logo-line"];

        // Overlay absent ou déjà retiré — on resolve sans relancer les animations
        if (!overlay || !loaderText) {
            bg?.remove();
            resolve();
            return;
        }

        // Home : l'intro se termine par l'ouverture du logo et le vol du nom vers le H1
        const isHome = !plainExit && !!document.querySelector('[data-barba-namespace="front"] #home-hero-media');

        // Setup typo
        gsap.set(loaderText, { opacity: 1, visibility: "visible" });
        const realText = "CÉDRIC STOECKLIN";
        const namePool = realText.replace(/\s/g, '').split('');

        loaderText.innerHTML = '';
        const charSpans = realText.split('').map((char) => {
            const span = document.createElement('span');
            span.dataset.ch       = char;
            span.style.display    = 'inline-block';
            span.style.width      = char === " " ? "30px" : "clamp(25px, 4.5vw, 55px)";
            span.style.textAlign  = "center";
            span.textContent      = char === " " ? " " : namePool[Math.floor(Math.random() * namePool.length)];
            loaderText.appendChild(span);
            return span;
        });

        // Sortie classique (toutes les pages sauf la home) : l'overlay remonte
        const endDefault = () => {
            gsap.to([overlay, bg].filter(Boolean), {
                yPercent: -100,
                duration: 1.1,
                ease: "expo.inOut",
                // startSiteCallback lancé pendant le slide-up (intentionnel)
                // pour que le site soit prêt quand l'overlay disparaît
                onStart: () => { if (startSiteCallback) startSiteCallback(); },
                onComplete: () => {
                    overlay.remove();
                    bg?.remove();
                    // refresh APRÈS que l'overlay soit sorti du DOM
                    ScrollTrigger.refresh(true);
                    resolve();
                }
            });
        };

        // Sortie home : le nom rejoint le H1, la photo s'ouvre depuis le logo
        const endHome = async () => {
            // Les lettres vont sortir du cadre du texte : on lève les overflow-hidden du loader
            overlay.style.overflow = 'visible';
            if (loaderText.parentElement) loaderText.parentElement.style.overflow = 'visible';
            await playHomeReveal({ bg, logo, subtitle, chars: charSpans });
            overlay.remove();
            bg?.remove();
            if (startSiteCallback) await startSiteCallback();
            ScrollTrigger.refresh(true);
            resolve();
        };

        const tl = gsap.timeline({
            onComplete: () => (isHome ? endHome() : endDefault()),
        });

        // Anim logo
        tl.to(logoParts, {
            strokeDashoffset: 0,
            duration: 1.2,
            ease: "power2.inOut"
        }, 0.2);

        // Scramble
        tl.to({ p: 0 }, {
            p: 1,
            duration: 1.4,
            ease: "power2.inOut",
            onUpdate: function() {
                const progress    = this.targets()[0].p;
                const revealIndex = Math.floor(realText.length * progress);
                const shouldUpdateRandom = Math.floor(gsap.ticker.frame % 6) === 0;

                charSpans.forEach((span, i) => {
                    if (realText[i] === " ") return;
                    if (i < revealIndex) {
                        if (span.textContent !== realText[i]) span.textContent = realText[i];
                    } else if (shouldUpdateRandom) {
                        span.textContent = namePool[Math.floor(Math.random() * namePool.length)];
                    }
                });
            },
            // Garantit le nom exact avant le vol des lettres
            onComplete: () => charSpans.forEach((span, i) => {
                if (realText[i] !== " ") span.textContent = realText[i];
            }),
        }, 0.3);

        // Sous-titre
        tl.to(subtitle, {
            opacity: 1,
            duration: 1,
            ease: "power2.out"
        }, 1.2);

        // Courte pause sur le nom complet avant la sortie
        tl.to({}, { duration: 0.3 });
    });
};